"use client";
import React, { useState } from "react";
export interface IFaqList {
  title: string;
  answer: string;
  qid: string;
}

const commonFaqList = [
  {
    title: "What is Kroolo?",
    answer:
      "Kroolo is an advanced SaaS-based productivity platform. It offers a comprehensive suite of tools to manage multiple projects, tasks and documents at one central space. From workspace and project management to task automation and AI-powered automation, Kroolo helps you to streamline everything to save your time 10x.",
    qid: "question-1",
  },
  {
    title: "How can I use Kroolo AI to automate my work?",
    answer:
      "Kroolo AI can be used to automate various tasks such as scheduling meetings, sending reminders, and generating reports. You can also use Kroolo AI to create custom workflows and automations to streamline your work processes.",
    qid: "question-2",
  },
  {
    title: "How is Kroolo different from other productivity platforms?",
    answer:
      "Kroolo offers a comprehensive suite of tools and features that are designed to help you manage multiple projects, tasks, and documents in one central space. Kroolo also has a strong focus on AI-powered automation, which can help you save time and improve efficiency.",
    qid: "question-3",
  },
  {
    title: "Can I start with a trial version before committing?",
    answer:
      "Yes, Kroolo offers a free trial version so you can test out the platform and see if it's a good fit for your needs before committing to a paid plan.",
    qid: "question-4",
  },
  {
    title:
      "Is there a limit on the number of users or workspaces in each plan?",
    answer:
      "The free plan allows you to have 5 workspaces with 10 team members. The plus plan increases the workspaces to 10 and team members to 50. The enterprise plan allows unlimited workspaces and up to 500 team members",
    qid: "question-5",
  },
  {
    title: "How can I boost my team's productivity with Kroolo?",
    answer:
      "Kroolo can help boost your team's productivity by streamlining workflows, automating tasks, and improving collaboration. By using Kroolo, your team can focus on their core tasks and get more done in less time.",
    qid: "question-6",
  },
];

const AiToolsFaq = ({
  faqTitle,
  faqList = [],
}: {
  faqTitle?: string;
  faqList?: IFaqList[];
}) => {
  const finalFaqList = faqList.length > 0 ? faqList : commonFaqList;
  const [openFaqId, setOpenFaqId] = useState<string | null>(() => {
    return finalFaqList.length > 0 ? finalFaqList[0].qid : null;
  });

  const toggleFaq = (faq: IFaqList) => {
    setOpenFaqId((currentOpenId) => {
      const isOpening = currentOpenId !== faq.qid;
      if (isOpening && typeof window !== "undefined" && window.dataLayer) {
        window.dataLayer.push({
          event: "faq_expand",
          faq_id: faq.qid,
          faq_title: faq.title,
          faq_section: faqTitle ?? "Frequently Asked Questions",
        });
      }
      return currentOpenId === faq.qid ? null : faq.qid;
    });
  };

  return (
    <div className="container">
      <div className="mx-auto py-12 xlg:max-w-4xl xlg:px-4">
        <h2 className="mb-12 text-center text-[24px] font-semibold text-[#202020] lg:text-[32px]">
          {faqTitle ? faqTitle : "Frequently Asked Questions"}
        </h2>
        <div className="space-y-4 xlg:space-y-6">
          {finalFaqList.map((faq) => {
            const isOpen = openFaqId === faq.qid;
            return (
              <div
                key={faq.qid}
                className="relative overflow-hidden rounded-lg bg-white p-1"
                style={
                  !isOpen
                    ? {
                      borderRadius: "10px",
                      padding: "1.4px",
                    }
                    : { padding: "1.4px" }
                }
              >
                <div
                  className={`rounded-lg transition-colors duration-300 ${isOpen ? "bg-gradient-to-r from-[#422CBB] to-[#781E8F] text-white" : "bg-gradient-to-r from-[#F4F4FD] to-[#FCFAF9]"
                    }`}
                  style={{ padding: "10px" }}
                >
                  <button
                    className="flex w-full items-center justify-between px-6 py-4 text-left focus:outline-none"
                    onClick={() => toggleFaq(faq)}
                    aria-expanded={isOpen}
                    aria-controls={`faq-answer-${faq.qid}`}
                  >
                    <h3 className="text-[16px] font-normal">{faq.title}</h3>
                    <svg
                      className={`h-5 w-5 transition-transform duration-300 ${isOpen ? "rotate-180 transform" : ""
                        }`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </button>
                  {isOpen && (
                    <div
                      id={`faq-answer-${faq.qid}`}
                      className="border-t border-[#FFFFFF] px-6 py-4"
                    >
                      <p className="text-[14px] font-light">{faq.answer}</p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AiToolsFaq;
